export default {
    state: {
        addTimePeriodsModal: false,
        editSingle: false,
        editMultiple: false,
        deleting: false,
    },

    mutations: {
        SET_ADD_TIME_PERIODS_MODAL(state, value) {
            state.addTimePeriodsModal = value;
        },

        SET_EDIT_SINGLE(state, value) {
            state.editSingle = value;
        },

        SET_EDIT_MULTIPLE(state, value) {
            state.editMultiple = value;
        },

        SET_DELETING(state, value) {
            state.deleting = value;
        },
    },
};
